import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import SwipeableTextMobileStepper from "./Carousel";
import moment from "moment";
import {
  getPassedList,
  getTransportationDetails,
} from "../../service/api";
import VerticalVehicleStepper from "../../components/Stepper/VerticalStepper";
import Loaderpage from "../LoaderPage";
import { Box } from "@material-ui/core";
import Pagination from "../../components/PaginationPassedPage";

export default function PassedVehicleList(props) {
  const [vehicleResponse, setVehicleResponse] = useState([]);
  const [transport, setTransport] = useState({});
  const [loader, setLoader] = React.useState(true);
  useEffect(() => {
    getVehicleDetails(1);
  }, [props.selectedDealersData]);

  async function getVehicleDetails(index) {
    const passedListResponse = await getPassedList(index);
    if (passedListResponse) getTransportDetails(passedListResponse?.data);
  }

  async function getTransportDetails(data) {
    if (data?.length !== 0) {
      let vinlistqueryparams = [];
      data.forEach((item, index) => {
        if (data?.length - 1 === index) {
          vinlistqueryparams.push(item.vin);
        } else {
          vinlistqueryparams.push(item.vin);
        }
      });
      let apiResponse = await getTransportationDetails(vinlistqueryparams);
      setTransport(apiResponse?.data);
      setVehicleResponse(data);
      setLoader(false);
    } else {
      setVehicleResponse(data);
      setLoader(false);
    }
  }

  const openConditionScreen = (VINumber, vehicle) => {
    props.history.push("/conditionreport", {
      vin: VINumber,
      vehicleDetails: vehicle,
    });
  };
  const onChangePage = (data, index) => {
    // console.log("data", data);
    getVehicleDetails(index);
  };

  const milesFormatter = new Intl.NumberFormat('en-US');
  return (
    <>
      {vehicleResponse?.length > 0 ? (
        <div>
          {vehicleResponse.map((vehicle, index) => {
            let imageSrc;
            const brand = vehicle?.brand;
            if(brand !=  null){
              switch(brand.toLowerCase()){
                case "toyota":
                  imageSrc = "inspection_pending_tfs.png";
                  break;
                case "lexus":
                  imageSrc = "inspection_pending_lfs.png";
                  break;
                case "mazda":
                  imageSrc = "inspection_pending_mfs.png";
                  break;
              }
            }
              else{
                const tenantId = localStorage.getItem("tenantId");
                if(tenantId !=  null){
                  switch(tenantId.toLowerCase()){
                    case "t001":
                      imageSrc = "inspection_pending_tfs.png";
                      break;
                    case "t002":
                      imageSrc = "inspection_pending_mfs.png";
                      break;
                  }
              }
            }
            if (!imageSrc) {
              imageSrc = "inspection_pending_tfs.png";
            }
            return (
              <div className="listingPageCard" key={index}>
                <Grid container spacing={3}>
                  <Grid item xs={4}>
                    {vehicle.inspection_mileage > 0 ? (
                      <SwipeableTextMobileStepper vehical={vehicle} images={vehicle.groundingImage} />
                    ) : (
                      <div className="pendingImgBlock">
                        <img
                          className="pendingImg"
                          src={imageSrc}
                          alt="pending"
                        />
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={4}>
                    <div className="Year-Make-Model-Col-details">
                      <div className="vehicleMakeModel">
                        <span>
                          {vehicle.model_year} {vehicle.brand} {vehicle.model} {vehicle.ext_color}{" "}

                        </span>
                      </div>
                      <List>
                        <span className="textStyle">
                          <span className="textBold"> VIN:</span>
                          <button style={{cursor:'pointer' ,border:'none',background:'none'}}
                            className="vin"
                            onClick={openConditionScreen.bind(
                              this,
                              vehicle.vin,
                              vehicle
                            )}
                          >
                            {" "}
                            &nbsp;
                            {vehicle.vin}
                          </button>
                        </span>

                        <span className="textStyle">
                          <span className="textBold"> Grounding Date:</span>{" "}
                          {moment(vehicle.grounding_date).format("MM/DD/YYYY")}
                        </span>
                        <span className="textStyle">
                          <span className="textBold"> Grounding Mileage:</span>{" "}
                          {vehicle?.odometer_reading && `${milesFormatter.format(vehicle?.adjMileage ? vehicle?.adjMileage : vehicle?.odometer_reading)} MI`}
                        </span>
                        <span className="textStyle">
                          <span className="textBold"> Inspection Mileage:</span>{" "}
                          {vehicle?.inspection_mileage ?
                            `${milesFormatter.format(vehicle.inspection_mileage)} MI`
                            : "Pending"}
                        </span>
                        <span className="textStyle">
                          <span className="textBold"> Account Type: </span>{" "}
                          {vehicle.account_type}
                        </span>
                      </List>
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <div className="VehicleStepper">
                      <VerticalVehicleStepper
                        vin={vehicle.vin}
                        transportData={transport}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            );
          })
          }

          {vehicleResponse?.length !== 0 ? (
            <Pagination
              showItemsPerPage={20}
              data={vehicleResponse}
              onChangePage={onChangePage}
            />
          ) : null}
        </div>
      ) : (
        <div>
          {loader ? (
            <Box
              height={"90vh"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <div>
                <Loaderpage />
                <span className="loaderText">Loading...</span>
              </div>
            </Box>
          ) : (
            <div className="listingPageCardNoData">
              <img alt="nodatafound" src="noDataFound.jpeg" className="nodataImage" />
              <span className="nodataText">No Vehicles found</span>
            </div>
          )}
        </div>
      )}
    </>
  )
}
